import {useAppDispatch, useAppSelector} from "../redux/hooks";
import {setUser} from "../redux/slices/user/userSlice";
import {RootState} from "../redux/store";
import Button from "../Atoms/Button";
import {ActiveContent} from "../redux/slices/content/contentType";
import {setActiveContent, setSidebarState} from "../redux/slices/content/contentSlice";
import {Icon} from "@mui/material";
import {
    AutoStoriesSharp, BallotSharp,
    DashboardSharp,
    KeyboardDoubleArrowLeft,
    KeyboardDoubleArrowRight,
    LogoutSharp, SportsEsportsSharp, VerifiedUserSharp
} from "@mui/icons-material";

export const Sidebar = (props: {}) => {
    const dispatch = useAppDispatch();
    const user = useAppSelector((state: RootState) => state.user);
    const content = useAppSelector((state: RootState) => state.content);

    const handleLogOut = () => {
        localStorage.removeItem('token');
        dispatch(setUser({
            userEmail: "",
            role: 0,
            userName: "",
            userId: 0,
            lastHostedAdventure: 0,
            lastPlayedAdventure: 0
        }))
    }

    const collapsedSidebar = () => {
        if (user.role < 1) {
            return (
                <div className='logout-btn-div'>
                    <div className='logout-btn'>
                        <Button className='collapsed-sidebar-button' onClick={handleLogOut}><LogoutSharp/></Button>
                        <Button className='change-sidebar-state-btn'
                                onClick={() => dispatch(setSidebarState(!content.isSidebarExpanded))}><KeyboardDoubleArrowRight/></Button>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <div>
                    <div className='sidebar-expanded-innerdiv'>
                        <div className=''>
                            <Button tooltip='Dashboard' className='collapsed-sidebar-button'
                                    onClick={() => handleChangeContent(ActiveContent.Dashboard)}><DashboardSharp/></Button>
                        </div>
                        <div className=''>
                            <Button tooltip='Kampagne' className='collapsed-sidebar-button'
                                    onClick={() => handleChangeContent(ActiveContent.Kampagne)}>
                                <SportsEsportsSharp/></Button>
                        </div>
                        {user.role > 1 && (
                            <div className=''>
                                <Button tooltip='Abenteuer' className='collapsed-sidebar-button'
                                        onClick={() => handleChangeContent(ActiveContent.Adventure)}><AutoStoriesSharp/></Button>
                            </div>
                        )}
                        {user.role > 2 && (
                            <div className=''>
                                <Button tooltip='Autorisierung' className='collapsed-sidebar-button'
                                        onClick={() => handleChangeContent(ActiveContent.Autorisierung)}>
                                    <VerifiedUserSharp/></Button>
                            </div>
                        )}
                        {user.role > 2 && (
                            <div className=''>
                                <Button tooltip='Standardinhalte' className='collapsed-sidebar-button'
                                        onClick={() => handleChangeContent(ActiveContent.Standardinhalte)}>
                                    <BallotSharp/></Button>
                            </div>
                        )}
                    </div>
                    <div className='logout-btn-div'>
                        <div className='logout-btn'>
                            <Button className='collapsed-sidebar-button' onClick={handleLogOut}><LogoutSharp/></Button>
                            <Button className='change-sidebar-state-btn'
                                    onClick={() => dispatch(setSidebarState(!content.isSidebarExpanded))}><KeyboardDoubleArrowRight/></Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const handleChangeContent = (content: ActiveContent) => {
        dispatch(setActiveContent(content));
    }

    const expandedSidebar = () => {
        if (user.role < 1) {
            return (
                <div className='logout-btn-div'>
                    <div className='logout-btn'>
                        <Button onClick={handleLogOut}><LogoutSharp/> Abmelden</Button>
                        <Button className='change-sidebar-state-btn'
                                onClick={() => dispatch(setSidebarState(!content.isSidebarExpanded))}><KeyboardDoubleArrowLeft/></Button>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <div className='sidebar-expanded-innerdiv'>
                    <div className=''>
                        <Button onClick={() => handleChangeContent(ActiveContent.Dashboard)}>
                            <DashboardSharp/> Dashboard</Button>
                    </div>
                    <div className=''>
                        <Button onClick={() => handleChangeContent(ActiveContent.Kampagne)}>
                            <SportsEsportsSharp/> Kampagne</Button>
                    </div>
                    {user.role > 1 && (
                        <div className=''>
                            <Button onClick={() => handleChangeContent(ActiveContent.Adventure)}>
                                <AutoStoriesSharp/> Abenteuer</Button>
                        </div>
                    )}
                    {user.role > 2 && (
                        <div className=''>
                            <Button onClick={() => handleChangeContent(ActiveContent.Autorisierung)}>
                                <VerifiedUserSharp/> Anfragen</Button>
                        </div>
                    )}
                    {user.role > 2 && (
                        <div className=''>
                            <Button tooltip='Standardinhalte'
                                    onClick={() => handleChangeContent(ActiveContent.Standardinhalte)}>
                                <BallotSharp/> Standardinhalte</Button>
                        </div>
                    )}
                </div>
                <div className='logout-btn-div'>
                    <div className='logout-btn'>
                        <Button onClick={handleLogOut}><LogoutSharp/> Abmelden</Button>
                        <Button className='change-sidebar-state-btn'
                                onClick={() => dispatch(setSidebarState(!content.isSidebarExpanded))}><KeyboardDoubleArrowLeft/></Button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={content.isSidebarExpanded ? 'sidebar-container-expanded' : 'sidebar-container-collapsed'}>
            {content.isSidebarExpanded ? expandedSidebar() : collapsedSidebar()}
        </div>
    )
}